export default __webpack_public_path__ + "static/DSC_0054-548976ff8a267195893404c3d9f44236.jpg";